class BackInStock extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;

    this.productId = parseInt(this.getAttribute('data-product-id'));
    this.triggerButton = this.querySelector('.KlaviyoBackInStockButton') || null;
    this.form = this.querySelector('form') || null;
    this.messageContainer = this.querySelector('.back-in-stock-message') || null;
    
    this.initListeners();
  }

  initListeners() {
    if (!this.triggerButton || !this.form) return;

    this.form.addEventListener('submit', (e) => {
      this.submit(e);
    });
  }

  async submit(e) {
    e.preventDefault();
    if (this.isLoading) return;
    this.isLoading = true;

    await this.subscribeToBIS({
      email: this.form.querySelector('input[name=email]').value,
      variant_id: this.form.querySelector('input[name=id]').value,
    }).then((response) => {
      if (response.errors) {
        const errorsList = response.errors.map((error) => `<li>${error.detail}</li>`).join('');
        this.messageContainer.innerHTML = `Something went wrong, please try again. <ul class="list-disc list-inside">${errorsList}</ul>`;
        this.messageContainer.classList.add('bg-error');
      } else {
        this.messageContainer.innerHTML = 'You have been subscribed to back in stock notifications!';
        this.messageContainer.classList.add('bg-success');

        this.form.querySelector('input[name=email]').value = '';
      }
    });

    this.isLoading = false;
    this.messageContainer.style.display = '';
    setTimeout(() => (this.messageContainer.style.display = 'none'), 8000);
  }

  async subscribeToBIS({ email, variant_id }) {
    const COMPANY_ID = 'VLdZCG';
    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${COMPANY_ID}`;

    console.log({
      email: this.form.querySelector('input[name=email]').value,
      variant_id: this.form.querySelector('input[name=id]').value,
    });

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-01-15',
        'content-type': 'application/vnd.api+json',
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                },
              },
            },
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variant_id}`,
              },
            },
          },
        },
      }),
    };

    const request = await fetch(url, options);
    const status = request.status;
    if (status == 202) {
      return { status: 'successful' };
    } else {
      const response = await request.json();
      return { status: 'error', errors: response.errors };
    }
  }
}

customElements.define('back-in-stock', BackInStock);